
import { Plugin } from 'ckeditor5/src/core';
import { createDropdown, addListToDropdown } from 'ckeditor5/src/ui';
import PlaceholderInsertPanelView from './ui/placeholderinsertpanelview';
import mediaIcon from './theme/icons/placeholder.svg';
import getDropdownItemsDefinitions from './utils';


export default class PlaceholderUI extends Plugin {

    static get pluginName() {
        return 'PlaceholderUI';
    }

    init() {
        const editor = this.editor;
        const command = editor.commands.get('placeholder');
        
        editor.ui.componentFactory.add('placeholder', locale => {
            const dropdown = createDropdown(locale);
            this._setUpDropdown(dropdown, command);
            return dropdown;
        });


        editor.ui.componentFactory.add('placeholder2', locale => {
            const dropdown = createDropdown(locale);
            this._setUpDropdown2(dropdown, command);
            return dropdown;
        });
    }

    _setUpDropdown(dropdownView, command) {

        const editor = this.editor;
        const t = editor.t;
        

        const panelView = dropdownView.panelView;
        panelView.extendTemplate({
            attributes: {
                class: 'ck-placeholder-insert__panel'
            }
        });

        const buttonView = dropdownView.buttonView;
        buttonView.set({
            label: 'Insert placeholder',
            icon: mediaIcon,
            tooltip: true
        });

        dropdownView.once('change:isOpen', () => {
            const form = new PlaceholderInsertPanelView(editor.locale, editor.config);
            dropdownView.panelView.children.add(form);
            // Note: Use the low priority to make sure the following listener starts working after the
            // default action of the drop-down is executed (i.e. the panel showed up). Otherwise, the
            // invisible form/input cannot be focused/selected.
            buttonView.on('open', () => {

                form.placeholder = ''; 

                const selectedElement = editor.model.document.selection.getSelectedElement();

                if (dropdownView.isOpen) {
                    if (selectedElement && selectedElement.name == 'placeholder') {
                        const name = selectedElement.getAttribute('name');
                        form.placeholder = name; 
                    }
                }

            }, { priority: 'low' });

            dropdownView.on('change:isOpen', () => form.resetFormStatus());

            dropdownView.on('submit', () => {
                closePanel();
                onSubmit();
            });
            dropdownView.on('cancel', () => {
                closePanel();
            });
            function onSubmit() {

                if (form.isValid()) {

                    console.log(form.placeholder);

                    editor.execute('placeholder', { value : form.placeholder });
                    editor.editing.view.focus();
                }

            }
            function closePanel() {
                editor.editing.view.focus();
                dropdownView.isOpen = false;
            }

            form.delegate('submit', 'cancel').to(dropdownView);
            form.placeholderInputView.fieldView.bind('value').to(dropdownView, 'value');
            // Form elements should be read-only when corresponding commands are disabled.
            form.placeholderInputView.bind('isEnabled').to(dropdownView, 'isEnabled');
        });

        dropdownView.bind('isEnabled').to(command);

    }


    _setUpDropdown2(dropdownView, command) {

        const editor = this.editor;
        const t = editor.t;

        // Populate the list in the dropdown with items.
        addListToDropdown(dropdownView, getDropdownItemsDefinitions(editor.config.get('placeholderConfig.types')));

        dropdownView.buttonView.set( {
            // The t() function helps localize the editor. All strings enclosed in t() can be
            // translated and change when the language of the editor changes.
            label: t( 'Placeholder' ),
            tooltip: true,
            withText: true
        } );

        // Disable the placeholder button when the command is disabled.
        dropdownView.bind( 'isEnabled' ).to( command );

        // Execute the command when the dropdown item is clicked (executed).
        this.listenTo( dropdownView, 'execute', evt => {
            editor.execute( 'placeholder', { value: evt.source.commandParam.value } );
            editor.editing.view.focus();
        } );

        return dropdownView;
    } 
    
}
